// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z3VH4J {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 48px;
  padding: 8px 24px;
  border-bottom: 1px solid var(--stroke-neutral-subtle, #e0e0e0);
  box-sizing: border-box;
  flex-shrink: 0;
}

.ZlF8Z6 {
  max-width: 250px;
  max-height: 40px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

.VMGWfv {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.424;
  color: var(--text-neutral-default, #232427);
  margin: 0;
  max-width: 600px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .z3VH4J {
    padding: 8px 16px;
    min-height: 40px;
  }

  .ZlF8Z6 {
    max-width: 180px;
    max-height: 32px;
  }

  .VMGWfv {
    font-size: 13px;
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PersonalizedHeader/PersonalizedHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,8DAA8D;EAC9D,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 48px;\n  padding: 8px 24px;\n  border-bottom: 1px solid var(--stroke-neutral-subtle, #e0e0e0);\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n\n.logo {\n  max-width: 250px;\n  max-height: 40px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.name {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.424;\n  color: var(--text-neutral-default, #232427);\n  margin: 0;\n  max-width: 600px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 8px 16px;\n    min-height: 40px;\n  }\n\n  .logo {\n    max-width: 180px;\n    max-height: 32px;\n  }\n\n  .name {\n    font-size: 13px;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `z3VH4J`,
	"logo": `ZlF8Z6`,
	"name": `VMGWfv`
};
module.exports = ___CSS_LOADER_EXPORT___;
